/** @format */

import React from 'react'
import { thanLastPeriod } from '../constants'
import { Tooltip, Icon, FormItem, Select, Option } from '@king-design/react'

interface UnitSelectProps {
  unitOpts: string[]
  compare: string
  units: string
  displayUnits: string
  onChange?: (value: string) => void
}

const UnitSelect: React.FC<UnitSelectProps> = ({
  unitOpts,
  compare,
  units,
  displayUnits,
  onChange
}) => {
  if (!unitOpts?.length) {
    if (thanLastPeriod.includes(compare)) {
      return <span style={{ padding: '0 8px' }}>%</span>
    } else if (units?.length <= 10) {
      return displayUnits || units ? (
        <span style={{ padding: '0 8px' }}>{displayUnits || units}</span>
      ) : null
    } else {
      return (
        <Tooltip content={units}>
          <Icon className="icon ion-help-circled" />
        </Tooltip>
      )
    }
  } else {
    if (!thanLastPeriod.includes(compare)) {
      return (
        <FormItem hideLabel={true} value={displayUnits || units} rules={{ required: true }}>
          <Select
            width={90}
            className="unit_select"
            value={displayUnits || units || ''}
            container=".select_position"
            onChangeValue={value => {
              onChange && onChange(value)
            }}
          >
            {unitOpts?.length
              ? unitOpts.map(item => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))
              : ''}
          </Select>
        </FormItem>
      )
    } else {
      return undefined
    }
  }
}

export default UnitSelect
